import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee17453e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "change-log"
}
const _hoisted_3 = {
  key: 1,
  class: "nolog-style"
}
const _hoisted_4 = {
  key: 0,
  class: "log-info van-hairline--top"
}
const _hoisted_5 = { class: "log-time-name" }
const _hoisted_6 = { class: "log-time-range" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-tips" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("div", null, " 系统已自动为您选择最后一个架次，若该架次不是实际故障架次，请点重新选择日志。若日志列表中找不到准确的架次，请等待架次更新。 ")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "wait-choose"
}
const _hoisted_9 = {
  key: 1,
  class: "change-log"
}
const _hoisted_10 = {
  key: 0,
  class: "log-info van-hairline--top"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-tips" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("div", null, " 系统自动炸机检测可能存在一定误差，如系统未检测出炸机，客户可自行按实际炸机日志选择并在故障报修页面修改故障标签为【炸机】。 ")
], -1))
const _hoisted_12 = [
  _hoisted_11
]

import { useRouter } from 'vue-router'
import { ref, Ref, onMounted, computed } from 'vue'
import { showConfirmModal, showToastLoading, clearToast } from '@/utils/tools'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'

import type { MalfunctionRepairDeviceItem, GetDeviceFlyLogsItem } from '@/types/malfunction-repair'
import { MalfunctionRepairSelectedDevicesStorage } from '@/storage/malfunction-repair'
import AppHeader from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import SelectBoom from './components/select-boom.vue'
import CommonWrap from '@/components/popup/common-wrap.vue'
import LabelTitleWrap from './components/label-title-wrap.vue'
import FaultLogItemTag from './components/fault-logitem-tag.vue'
import FaultFormDeviceInfo from './components/fault-form-device.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-logs',
  setup(__props) {

const $router = useRouter()
const cacheDeviceInfo = MalfunctionRepairSelectedDevicesStorage.get<MalfunctionRepairDeviceItem[]>()
const deviceInfoList: Ref<MalfunctionRepairDeviceItem[]> = ref(cacheDeviceInfo || [])
const sn = deviceInfoList.value[0].serial_number
const boomPopupShow = ref(false)
const {
  malfunctionRepairState,
  initFlylogs,
  changeSelectedLogGuid,
  changeBoomValue,
  removeNetworkListKeepAlive,
  setSelectedLogItem,
} = useMalfunctionRepairStore()
const isUnLoadFlylog = malfunctionRepairState.flylogsSnMap[sn] === undefined // 用于判断飞行日志为空是没有加载过还是加载过但是为空的情况
const flyLogs: Ref<GetDeviceFlyLogsItem[]> = ref(malfunctionRepairState.flylogsSnMap[sn] || [])
const canLogSelect = ref(false)
const selectedLog = computed(() => {
  const selectedLogGuid = malfunctionRepairState.selectedLogGuid
  return flyLogs.value.filter((item) => item.guid === selectedLogGuid)[0]
})
const canNext = computed(() => {
  return (
    malfunctionRepairState.isBoom !== undefined && (flyLogs.value.length === 0 || selectedLog.value)
  )
})
const noLogTips = ref('')
async function getFlylogs() {
  // 初始化飞行日志数据
  try {
    if (flyLogs.value.length === 0 && isUnLoadFlylog) {
      showToastLoading({
        message: '故障识别中...',
      })

      // 没有加载过飞行日志的情况需要请求，若加载过，可以直接判断为没有飞行日志，减少请求
      const data = await initFlylogs(sn)
      flyLogs.value = data
    }
    // 炸机时优先选择最新的炸机，没有炸机时选择最新的
    const boomList = flyLogs.value.filter((item) => item.isBoom)
    let item: GetDeviceFlyLogsItem
    console.log('boomList', boomList)
    if (boomList.length) {
      // 如果存在炸机的
      item = boomList[0]
    } else {
      item = flyLogs.value[0]
    }
    // const item = flyLogs.value[0]
    if (flyLogs.value.length > 0) {
      canLogSelect.value = true
      if (!malfunctionRepairState.selectedLogGuid || !selectedLog.value) {
        changeSelectedLogGuid(item.guid)
        changeBoomValue(item.isBoom)
      }
    }
  } catch (error) {
    //commonErrorHandle(error)
    // return
  }
  clearToast()

  if (!canLogSelect.value) {
    setTimeout(() => {
      noLogTips.value = '设备未检测到日志，无法选择'
      showConfirmModal({
        title: '系统查询不到当前设备的飞行日志，请点击确定后按实际情况选择炸机情况标签！',
        message: '',
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-common-class',
        showCancelButton: false,
      })
    }, 100)
  }
}
function confirmSelectHandle() {
  boomPopupShow.value = false
}
function toSelectLog() {
  if (!canLogSelect.value) {
    return
  }
  $router.push({
    name: 'malfunction-repair-fault-log-select',
    query: {
      sn,
      guid: selectedLog.value.guid,
    },
  })
}
function nextHandle() {
  setSelectedLogItem(selectedLog.value)
  const query = {
    guid: malfunctionRepairState.selectedLogGuid || '',
    sn,
    is_boom: malfunctionRepairState.isBoom ? 'true' : 'false',
  }
  // 没有炸机日志时直接跳转网点选择
  $router.push({
    name: query.guid ? 'malfunction-repair-log-analysis' : 'malfunction-repair-network-list',
    query,
  })
}
onMounted(() => {
  getFlylogs()
  removeNetworkListKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "日志分析" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LabelTitleWrap, { title: "报修设备" }),
      _createVNode(FaultFormDeviceInfo, { deviceInfoList: deviceInfoList.value }, null, 8, ["deviceInfoList"]),
      _createVNode(LabelTitleWrap, {
        title: "故障日志",
        class: "fault-log"
      }),
      _createVNode(CellWrap, {
        label: "故障日志",
        required: "",
        showArrow: canLogSelect.value,
        fillColor: canLogSelect.value ? '' : 'rgba(0, 0, 0, 0.44)',
        onClick: toSelectLog
      }, {
        "cell-right": _withCtx(() => [
          (canLogSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "更换日志"))
            : _createCommentVNode("", true),
          (!canLogSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(noLogTips.value), 1))
            : _createCommentVNode("", true)
        ]),
        block: _withCtx(() => [
          (_unref(selectedLog))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(_unref(selectedLog)?.name), 1),
                  _createVNode(FaultLogItemTag, {
                    isBoom: _unref(selectedLog).isBoom
                  }, null, 8, ["isBoom"])
                ]),
                _createElementVNode("div", _hoisted_6, "时长" + _toDisplayString(_unref(selectedLog)?.longStr), 1),
                _hoisted_7
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["showArrow", "fillColor"]),
      _createVNode(LabelTitleWrap, {
        title: "炸机情况",
        class: "boom-item"
      }),
      _createVNode(CellWrap, {
        label: "是否炸机",
        required: "",
        fillColor: _unref(malfunctionRepairState).isBoom === undefined ? 'rgba(0, 0, 0, 0.44)' : '',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (boomPopupShow.value = true))
      }, {
        "cell-right": _withCtx(() => [
          (_unref(malfunctionRepairState).isBoom === undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "请选择"))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(malfunctionRepairState).isBoom ? '' : '非') + "炸机", 1))
        ]),
        block: _withCtx(() => [
          (_unref(selectedLog))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["fillColor"])
    ]),
    _createVNode(CommonWrap, {
      title: "炸机情况",
      show: boomPopupShow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((boomPopupShow).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(SelectBoom, {
          onConfirm: confirmSelectHandle,
          show: boomPopupShow.value
        }, null, 8, ["show"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(CommonFooterNextButton, {
      disabled: !_unref(canNext),
      onClick: nextHandle
    }, null, 8, ["disabled"])
  ], 64))
}
}

})